import { Calendar, Clock, FileText, MoreHorizontal, Send, X } from "lucide-react";

const CallOutcomeBadge = ({ outcome }) => {

    if (!outcome) {
        return null;
    }

    let icon = null
    let label = '';

    const iconProps = { size: 12, className: "mr-1" }

    switch (outcome) {
        case "tour-scheduled":
            label = 'Tour Booked';
            icon = <Calendar {...iconProps} />
            break;
        case "requested-application":
            label = 'Requested Application';
            icon = <FileText {...iconProps} />
            break;
        case "submitted-application":
            label = 'Submitted Application';
            icon = <Send {...iconProps} />
            break;
        case "not-interested":
            label = 'Not Interested';
            icon = <X {...iconProps} />
            break;
        case "bad-timing":
            label = 'Bad Timing';
            icon = <Clock {...iconProps} />
            break;
        case "other":
            label = 'Other';
            icon = <MoreHorizontal {...iconProps} />
            break;
        case "no-progress":
            label = 'No Progress';
            icon = <Clock {...iconProps} />
            break;
        default:
            break;
    }


    return (
        <span className="inline-flex items-center py-[2px] px-[6px] text-[12px] font-medium text-gray-900 bg-gray-50 border border-gray-200 rounded-md whitespace-nowrap">
            {icon}
            {label}
        </span>
    )
}

export default CallOutcomeBadge;